export default "__VITE_ASSET__BaI1J8eA__"